import React from "react";
import { View, StyleSheet } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DetailCommon from "./DetailViewCommon";
import { COLORS } from "../../../constants";
/**
 * DetailsViewWeb Component
 *
 * This component renders the details of an event specifically for a web environment using react-native-web.
 * It displays the name, date, time, and location of an event, making use of the DetailCommon component for the UI.
 *
 * Props:
 *  - route: Contains parameters passed through the navigation stack, including the event details.
 *
 * @file DetailsViewWeb.js
 * @module DetailsViewWeb
 */
const DetailsViewWeb = ({ route }) => {
  return (
    <View style={styles.container}>
      <DetailCommon route={route} FontAwesomeIcon={FontAwesomeIcon} iconSize="lg" chipSize="lg" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.textLight,
    padding: 16,
  },
});

export default DetailsViewWeb;
